import {defaultQuery} from '@/store/services';

// Endpoint shapes and reporting definitions: docs/dashboard-api.md.
async function overview(params) {
    const response = await defaultQuery('dashboard/overview', params);
    if (!response.resource) throw new Error('Dashboard overview unavailable');
    return response.resource;
}

async function analytics(params) {
    const response = await defaultQuery('dashboard/analytics', params);
    if (!response.resource) throw new Error('Dashboard analytics unavailable');
    return response.resource;
}

export default {overview, analytics};
